import { memo } from "react";
import { useTranslation } from "react-i18next";

function InternationalMarkets() {
  const { t } = useTranslation();
  return (
    <main className="container mt-5" aria-label={t("page.intlMarkets.aria")}>
      <div className="row">
        <h1>{t("page.intlMarkets.title")}</h1>
      </div>
    </main>
  );
}

InternationalMarkets.displayName = "InternationalMarkets";

export default memo(InternationalMarkets);
